module.exports = __webpack_public_path__ + "img/delete.96965be5.svg";